
import axios from "axios";
import Vue from "vue";
import configuration from "@/utils/configuration";


const eventsModules = {
    namespaced: true,
    state: {
        eventLists: [],
        error: {},

    },
    mutations: {
        SET_EVENT_LISTS(state, eventLists) {
            state.eventLists = eventLists
        },
        SET_ERROR(state, { action, message }) {
            Vue.set(state.error, action, message);
        },
    },
    actions: {
        async uploadEventsList({ commit }, formData) {
            const action = "uploadEventsList";
            try {
                const { data } = await axios({
                    method: "POST",
                    withCredentials: true,
                    url: `${configuration.backUrl}/events/`,
                    headers: { 'Content-Type': 'multipart/form-data' },
                    data: formData,
                });

                return data
            } catch (error) {
                const message = error.response?.data?.message?.message || "Upload failed";
                commit("SET_ERROR", { action, message });
                throw new Error(message);
            }
        },

        async deleteEvent({ commit }, eventId) {
            const action = "deleteEvent";
            try {
                const { data } = await axios({
                    method: "DELETE",
                    url: `${configuration.backUrl}/events`,
                    params: { event_id: eventId },
                    withCredentials: true,
                });

                commit("SET_EVENT_LISTS", data.data);
                return data.data
            } catch (error) {
                commit("SET_ERROR", { action, message: error.response?.data?.message || error.message || `${action} Failed`, });
            }
        },

        async getEventLists({ commit }) {
            const action = "getEventLists";
            try {
                const { data } = await axios({
                    method: "GET",
                    url: `${configuration.backUrl}/events/`,
                    withCredentials: true,
                });

                commit("SET_EVENT_LISTS", data.data);
                return data.data
            } catch (error) {
                commit("SET_ERROR", { action, message: error.response?.data?.message || error.message || `${action} Failed`, });
            }
        }
    },
    getters: {
        eventLists: (state) => state.eventLists,
    },

}
export default eventsModules;
